export default __webpack_public_path__ + "static/media/Login_Screen.72dd5dd8.png";